import { useCallback, useContext, useMemo } from 'react';
import { distinct } from '@trinity/chat-components/utils';
import { addYears } from 'date-fns';
import { z } from 'zod';
import { useCookie } from '@trinity/chat-components/hooks/useCookie';
import { AuthorContext } from '../context';

const COOKIE_NAME = `chat-guidelines-shown`;

export const useChatGuidelinesCookie = () => {
  const [cookieVal, setCookieVal] = useCookie(COOKIE_NAME, '[]', { watchForChanges: true });

  const userArray = useMemo(() => {
    try {
      const parsedVal = z.array(z.string()).safeParse(JSON.parse(cookieVal));

      if (!parsedVal.success) {
        console.log(`Invalid cookie ${COOKIE_NAME}. Error: ${parsedVal.error}`);
        setCookieVal({ value: '[]', expires: addYears(new Date(), 1) });
        return [];
      }

      return parsedVal.data;
    } catch {
      return [];
    }
  }, [cookieVal, setCookieVal]);

  const author = useContext(AuthorContext);
  const userIdentifier = author.identifier;

  const isDismissed = useMemo(() => {
    return userArray.includes(userIdentifier);
  }, [userArray, userIdentifier]);

  const dismissGuidelines = useCallback(() => {
    if (!userIdentifier) return;

    const userArr = distinct([...userArray, userIdentifier]);

    setCookieVal({ value: JSON.stringify(userArr), expires: addYears(new Date(), 1) });
  }, [setCookieVal, userArray, userIdentifier]);

  return { isDismissed, dismissGuidelines };
};